import {
  useMediaQuery
} from "../chunk-EP5LHGDZ.js";
export {
  useMediaQuery
};
